import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Tabs, Tab, Divider, colors, Paper, Button, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Checkbox, ListItemText, Box, Chip, Typography } from '@mui/material';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { Header, Page, PowerBIDashboard } from 'components';
import { MultiSelect } from 'views/ProjectList/components/Filter/components';
import { SetExportSelection, ExportTables } from './actions/EnergySmartScoreDashboardActions';
import DashboardInspect from '../Dashboard/components/Inspect/DashboardInspect';

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: '100%',
		margin: '0 auto',
		padding: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	divider: {
		backgroundColor: colors.grey[300],
	},
	alert: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	spaced: {
		marginTop: theme.spacing(3)
	},
	hint: {
		marginTop: theme.spacing(1)
	},
	paper: {
		marginTop: theme.spacing(3),
		maxWidth: '100%',
		margin: '0 auto',
		padding: theme.spacing(3),
	},
	exportBtn: {
		marginLeft: theme.spacing(3)
	}
}));

const EnergySmartScoreDashboard = (props) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const exportOptions = ['MODEL_EFF', 'MODEL_EI', 'MODEL_SE', 'MODEL_TOPO'];
	const [selectedExports, setSelectedExports] = useState([]);
	const { match, headerHidden, module, pageTitle, project } = props;

	const exportTables = () => {
		if (selectedExports.length > 0) {
			dispatch(ExportTables(selectedExports, project));
		}
	};

	return (
		<DashboardInspect
			headerHidden={headerHidden}
			match={match}
			module={module}
			pageTitle={pageTitle}
		>
			<Paper className={classes.paper} elevation="1">
				<Typography variant="h5">Export tables</Typography>
				<div className={classes.spaced}>
					<MultiSelect
						label="Choose tables"
						onChange={setSelectedExports}
						options={exportOptions}
						value={selectedExports}
					/>
					<Button
						onClick={exportTables}
						name="ExportBtn"
						value="Test"
						variant="contained"
						className={classes.exportBtn}
					>
						Export
					</Button>
				</div>
				<Typography variant="overline" display="block" gutterBottom className={classes.hint}>
					{selectedExports.length}
					{' '}
					tables selected.
				</Typography>
			</Paper>
		</DashboardInspect>
	);
};

EnergySmartScoreDashboard.propTypes = {
	match: PropTypes.object.isRequired,
	pageTitle: PropTypes.string,
	project: PropTypes.string,
	headerHidden: PropTypes.bool,
	module: PropTypes.string
};

export default EnergySmartScoreDashboard;
